import { createContext } from 'react'

import { noopTelemetry } from './telemetry-contract'

export const TelemetryContext = createContext(noopTelemetry)
